import React from "react";
import { Row, Menu, Select } from "antd";

export default function ResourceList(props) {
  console.log("props.resourceList", props.resourceList);
  const menu = (
    <Menu>
      <Menu.Item
        key="resmenu_1"
        onClick={() => {
          props.addNewResource("Rest API");
        }}
      >
        Rest Api
      </Menu.Item>
      <Menu.Item
        key="resmenu_2"
        onClick={() => {
          props.addNewResource("Combined Resource");
        }}
      >
        Combined Resource
      </Menu.Item>
      {/* not configured yet - hidden until the connectors exist
      <Menu.Item key="resmenu_3">SQL database</Menu.Item>
      <Menu.Item key="resmenu_4">NoSql Database</Menu.Item> */}
    </Menu>
  );

  /* Changing the type rewrites THIS block. It used to call addNewResource, which added
     another resource - fine when the panel showed one resource, wrong now it is a list. */
  const handleSelectAPI = (API) => {
    if (props.onChangeResourceType) {
      props.onChangeResourceType(API);
      return;
    }
    props.addNewResource(API);
  };

  const { Option } = Select;

  return (
    <div>
      <Row>
        <div className="rest-api-selector-field">
          <label>API Type</label>

          <Select
            placeholder="Select API Type"
            value={props.selectedResource?.type || undefined}
            onChange={(value) => {
              handleSelectAPI(value);
            }}
          >
            <Option value="Rest API">REST API</Option>
            <Option value="Combined Resource">Combined Resource</Option>
            {/* not configured yet - hidden until the connectors exist
            <Option value="Sql Database">SQL database</Option>
            <Option value="NoSql Database">NoSql Database</Option> */}
          </Select>
        </div>
      </Row>
    </div>
  );
}
